import React, { Component } from 'react';
import { Table } from "reactstrap";
import { Button } from "../../../components";
import {Link} from 'react-router-dom'
import { getStoreStaffs, deleteStoreStaff } from '../../../actions/storeStaffActions';
import {connect} from 'react-redux';
import userAvatar from "../../../assets/img/avatar.png";
import ReactPaginate from 'react-paginate';
import SweetAlert from 'sweetalert2-react';
import{onDismiss} from '../../../actions/storeActions';

class Users extends Component {
    constructor(){
        super();
        this.state = { 
           skip:0,
           limit:12,
           alert:false,selectedAdminId:0,
           isAdmin: false
         }
    }

    //WARNING! To be deprecated in React v17. Use componentDidMount instead.
    componentWillMount() {
      setTimeout(()=>{
        var isAdmin = this.props.match.url.includes('admin');
        this.setState({isAdmin})
        this.props.onGetStaffs(this.props.store?this.props.store.id:0,this.state.skip,this.state.limit)
       },100);
    }

    getLoder() {
      let classes = "bt-loader ";
      classes += this.props.staffLoading ? 'bt-show' : 'bt-hide';
      return classes;
    }

    getLoder2() {
      let classes = "bt-loader ";
      classes += this.props.staffLoading ? 'bt-show' : 'bt-hide';
      return classes;
    }

    handlePageClick = (data) => {
      let selected = data.selected;
      let skip = selected * this.state.limit
      this.setState({skip: skip});
      this.props.onGetStaffs(skip,this.state.limit);
    }

    onDismissPopup =()=>{
      this.props.onDismiss();
      this.props.onGetStaffs(this.props.store?this.props.store.id:0,this.state.skip,this.state.limit)
    }

    onConfirm = ()=>{
     
      this.props.onDeleteStaff(this.state.selectedAdminId);
      this.setState({alert:false})
      // {this.props.onGetStores(this.state.skip,this.state.limit)}
    }

    onDelete = (admin_id)=>{
      this.setState({
        alert:true,
        selectedAdminId:admin_id
      })
    }

    render() { 
      const {staffs} = this.props;
        return ( 
            <div>
                <div className="content">
                <div className={this.getLoder()}></div>
                <div className={this.getLoder2()}></div>
                <div className="table-product-wrapper">
                  <Table>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th/>
                        <th>USERNAME</th>
                        <th>MOBILE NO </th>
                        <th>EMAIL</th>
                        <th>ACTIONS</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                    {staffs.length>0 ? staffs.map((user,index) => (
                        <tr key={user.id}>
                        <td>
                          {index+1+this.state.skip}

                        </td>
                        <td className="nameImg">
                        <img src={user && user.profile_pic ? user.profile_pic: userAvatar} alt="wild" className="img-round" />
                        </td>
                        <td>{user.name}</td>
                        <td>{user.mobile}</td>
                        <td>{user.email}</td>
                        <td>
                          <div className="group-action">
                            <Link className="btn" to={this.state.isAdmin?`/admin/edit-store-staff/${user.id}`: `/store/edit-store-staff/${user.id}`}>
                              <i className="ico icon-edit" />
                            </Link>
                            <button className="btn" onClick={() => this.onDelete(user.id)}>
                              <i className="ico icon-delete" />
                            </button>
                          </div>
                        </td>
                      </tr>    
                    )):<tr><td colSpan={'7'}>No data found</td></tr>}
                        
                     
                    </tbody>
                  </Table>
                 
                {!this.state.isAdmin && <Button className="fixed-yellow"  onClick={() => this.props.history.push("/store/add-store-staff")}>Add</Button>}
                </div>
                <div className="pagination-wrapper">
                <ReactPaginate previousLabel={<i className="fas fa-angle-left"></i>}
                  nextLabel={<i className="fas fa-angle-right"></i>}
                  pageLinkClassName={"page-link"}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(this.props.count/this.state.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  activeClassName={"active"} 
                  />
                  </div>

                  <SweetAlert
                    show={this.state.alert }
                    onConfirm={this.onConfirm}
                    onCancel = {() => this.setState({ alert: false })}
                    title= {'Are you sure?'}
                    text="Change status"
                    type= {'warning'}
                    showCancelButton= {true}
                    confirmButtonText= {'Yes, Confirm it!'}
                    cancelButtonText= {'No, keep it'}
                  />
                  <SweetAlert
                  show={this.props.status && this.props.popup}
                  title="Success"
                  text={this.props.message}
                  onConfirm={this.onDismissPopup}
                  />
                  <SweetAlert
                  show={ !this.props.status && this.props.popup}
                  title="Error"
                  type="error"
                  text={this.props.message}
                  onConfirm={this.onDismissPopup}
                  />



                </div>

            </div>
        );
    }
}

Users.defaultProps = {
  staffs:[]
}

const mapStateToProps = state=>({
  staffs: state.StaffReducer.staffs,
  status: state.StaffReducer.status,
  deleteLoading:state.StaffReducer.deleteLoading,
  popup: state.StaffReducer.popup,
  message:state.StaffReducer.message,
  count:state.StaffReducer.count,
  staffLoading: state.StaffReducer.staffLoading,
  store:state.storeUserReducer.store
})

const mapDispatchToProps = dispatch=>({
  onGetStaffs:(store_id,skip,take)=>{
    dispatch(getStoreStaffs(store_id,skip,take))
  },
  onDeleteStaff:(admin_id)=>{
    dispatch(deleteStoreStaff(admin_id))
  },
  onDismiss:()=>{
    dispatch(onDismiss())
  }
})


export default connect(mapStateToProps,mapDispatchToProps) (Users);